import React from 'react';

export const UsersListItemLoading = () => {
    return (
        <li className="list-group-item">
            <div className="row">
                <div className="placeholder-glow col-lg-3 col-xl-4">
                    <span className="placeholder w-100 mt-1 mb-2"></span>
                </div>
                <div className="placeholder-glow col-lg-4 col-xl-4">
                    <span className="placeholder w-100 mt-1 mb-2"></span>
                </div>
                <div className="placeholder-glow col-lg-2 col-xl-2">
                    <span className="placeholder w-100 mt-1 mb-2"></span>
                </div>
                <div className="col-lg-3 col-xl-2">
                    <div className="d-grid">
                        <span className="btn btn-primary disabled placeholder mb-2"></span>
                    </div>
                </div>
            </div>
        </li>
    );
};
